import superagent from 'superagent'

/**
 * OAuth sign-in and consent (WEB-7106) against the API-3653 endpoints. Services parks an authorization
 * request from an AI platform, a partner app or developers.basemap.com and sends the browser to
 * /oauth/consent?oauthRequest=<id>. These two calls, made with the user's BaseMap token, read what to
 * show and record the decision.
 *
 * Services words its failures for the user (an expired request, a disabled app, one already completed),
 * so the body's message is shown as it is.
 */

const messageFrom = (err, fallback) => {
  const body = err && err.response ? err.response.text : null

  if (!body) return fallback

  // Messages come back as a quoted JSON string; unwrap it rather than showing the quotes.
  const trimmed = body.trim()
  try {
    const parsed = JSON.parse(trimmed)
    if (typeof parsed === 'string' && parsed.length) return parsed
  } catch (e) {
    // Not JSON - fall through and use the raw body.
  }

  return trimmed.length ? trimmed : fallback
}

const failure = (err, fallback) => {
  const error = new Error(messageFrom(err, fallback))
  error.status = err && err.status
  return error
}

const withHeaders = request => request
  .set('Content-Type', 'application/json')
  .set('Platform', 'Web')
  .set('Version', `${__version__}`)

const oauthConsent = {
  /** {client: {clientId, name, logoUri, partner, firstParty}, scopes: [{name, description}], plan, redirectHost, redirectIsLoopback} */
  getConsent: ({ oauthRequest, token }) => {
    return new Promise((resolve, reject) => {
      withHeaders(superagent.get(`${__API_URI__}/OAuth/Consent`))
        .query({ oauthRequest })
        .set('Authorization', `Bearer ${token}`)
        .end((err, res) => {
          if (err) return reject(failure(err, 'This sign-in request could not be found.'))
          resolve(res.body)
        })
    })
  },

  /** Records Approve or Deny. Resolves to {continueUrl}, where the browser goes next. */
  complete: ({ oauthRequest, approve, token }) => {
    return new Promise((resolve, reject) => {
      withHeaders(superagent.post(`${__API_URI__}/OAuth/Complete`))
        .set('Authorization', `Bearer ${token}`)
        .send({ oauthRequest, approve })
        .end((err, res) => {
          if (err) return reject(failure(err, 'Your answer could not be saved.'))
          resolve(res.body)
        })
    })
  }
}

export default oauthConsent
